import { types } from 'mobx-state-tree';
import moment from 'moment';

const ordersStatuses = ['New', 'InProgress', 'Fail', 'Success'];

const currentDate = moment().format('YYYY-MM-DD HH:mm:ss');
const twoDaysAgoFromCurrentDate = moment(currentDate)
  .subtract(2, 'd')
  .format('YYYY-MM-DD HH:mm:ss');

const ExtOrdersParamsV2 = types
  .model('ExtOrdersParams', {
    externalSource: '',
    pageNumber: 1,
    limit: 20,
    status: '',
    total: 0,
    startDate: types.optional(types.string, twoDaysAgoFromCurrentDate),
    endDate: types.optional(types.string, currentDate),
    text: '',
  })
  .actions(self => ({
    setPage(pg) {
      self.pageNumber = pg;
    },
    setStatus(i) {
      self.status = ordersStatuses[i] || '';
    },
    setLimit(t) {
      self.limit = t;
    },
    setTotal(t) {
      self.total = t;
    },
    setStartDate(e) {
      if (e && moment(e).isBefore(moment())) {
        self.startDate = moment(e).format('YYYY-MM-DD HH:mm:ss');
        console.log('start: ', self.startDate);
      } else if (e === null) {
        self.startDate = '';
      }
    },
    setEndDate(e) {
      self.endDate = moment(e).format('YYYY-MM-DD HH:mm:ss');
    },
    setText(t) {
      self.text = t;
    },
    resetValues() {
      self.pageNumber = 1;
    },
    clearFilters() {
      self.status = '';
      self.startDate = twoDaysAgoFromCurrentDate;
      self.endDate = currentDate;
      self.text = '';
    },
  }));

export default ExtOrdersParamsV2;
